import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

/** Apple-style back affordance. Uses history when available, else the fallback route. */
export const BackLink = ({ fallback = "/", label, className = "", testid = "back-link" }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handle = (e) => {
    e.preventDefault();
    if (window.history.state && window.history.state.idx > 0) navigate(-1);
    else navigate(fallback);
  };

  return (
    <Link
      to={fallback}
      onClick={handle}
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-sm text-[#737373] hover:text-[#0A0A0A] transition-colors duration-200 w-fit ${className}`}
    >
      <ArrowLeft className="w-4 h-4" aria-hidden="true" />
      {label || t("common.back")}
    </Link>
  );
};
